import { render, staticRenderFns } from "./Onepage.vue?vue&type=template&id=37e9307e&scoped=true&"
import script from "./Onepage.vue?vue&type=script&lang=js&"
export * from "./Onepage.vue?vue&type=script&lang=js&"
import style0 from "./Onepage.vue?vue&type=style&index=0&id=37e9307e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e9307e",
  null
  
)

export default component.exports